import * as t from 'io-ts';

export const scoreTriggerCodec = t.type({
  operator: t.union([t.literal('<'), t.literal('>'), t.literal('between')]),
  from: t.number,
  to: t.number,
});
